import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Pagination } from 'src/app/core';

@Component({
  selector: 'app-card-pagination',
  templateUrl: './card-pagination.component.html',
  styleUrls: ['./card-pagination.component.less'],
})
export class CardPaginationComponent implements OnInit {
  @Input() page: number = 1;
  @Input() perPage: number = 10;
  @Input() lastPage: number;
  @Input() totalCount: number;
  @Input() nzSimple: boolean = false;
  @Input() showSizeChanger: boolean = false;
  @Input() showQuickJumper: boolean = false;
  @Input() nzPageSizeOptions: number[] = [10, 20, 30, 40];

  @Output() pagination: EventEmitter<Pagination> = new EventEmitter<
    Pagination
  >();

  constructor() {}

  ngOnInit(): void {}

  pageIndexChange(index: number) {
    this.page = index;
    this.pagination.emit({ page: this.page });
  }

  pageSizeChange(size: number) {
    this.page = 1;
    this.perPage = size;
    this.pagination.emit({
      page: this.page,
      perPage: this.perPage,
    });
  }
}
